export default __webpack_public_path__ + "static/blog-3-a320d85ecf55bfa5e4f2bca6d6eb5790.jpg";